<template>
  <div
    ref="bulletList"
    class="bullet-title vertical layout center-justified"
    :class="{'bullet-presenting': $store.getters.isPresenting || isBackstage}"
    @click="tabBulletPoint()"
  >
    <div :class="{ 'mh-100': !isResizable }" ref="bulletContent">
      <div class="bullet-heading">
        <SlideTitleEditor
          :class="classHeading"
        />
      </div>
    </div>
    <p
      class="bullet-subheading"
      :class="classSubheading"
      v-if="slideActive.subheading && slideActive.subheading != ' '"
      @click="_editSubheading"
      :inner-html.prop="slideActive.subheading | sanitize(true)"
    />

    <!-- <div class="audio-control-slide" v-if="isShowAudio">
      <AudioControl />
    </div> -->

    <div
      class="bullet-point-content horizontal layout center-justified"
      :class="{'hide-bullet-point': !slideActive.showAllBulletPoints}"
    >
      <div class="horizontal layout box-max-h box-clumn center-justified">
        <div
          class="flex horizontal layout"
          v-for="(list, index) in bulletPoints"
          :key="index"
          :class="{
            'center-justified': bulletPoints.length == 1,
            'column-layout': bulletPoints.length > 1,
          }"
        >
          <div class="bullet-list" :class="classBullet" :style="listStyle">
            <ul class="list-disc ml-9">
              <li
                v-for="(item, indexBullet) in list"
                :key="item.id || indexBullet"
                @click="_editBulletPoints($event,item.id)"
                class="bullet-list-listing"
                :class="{'show': item.show}"
              >
                <p class="mb-3" v-if="item.id" :inner-html.prop="item.title | sanitize(true)" />
                <p
                  class="mb-3"
                  v-if="!item.id && slideActive.SlideOptions.length < 4"
                >
                  Bullet {{ indexBullet + 1 }}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Socket from '@/socket'
import Util from '@/util'
import EventBus from '@/eventBus'

// import AudioControl from '@/components/presentations/AudioControl'
import SlideTitleEditor from '@/components-v2/presentation-editor/middle/SlideTitleEditor.vue'
// api
import SlideApi from '@/api/slide'

export default {
  components: {
    // AudioControl,
    SlideTitleEditor,
  },
  data() {
    return {
      bulletPoints: [],
      slideId: null,
      classHeading: '',
      classSubheading: '',
      // isShowAudio: false,
      fontSize: 20,
      minFontSize: 8,
      maxFontSize: 32,
      trend: null,
      timer: null,
    }
  },
  computed: {
    ...mapGetters(['isPresenting', 'isBackstage']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      activeSlideId: (state) => state.activeSlideId,

    }),
    listStyle() {
      if (!this.isResizable) return null

      return { fontSize: `${this.fontSize}px` }
    },
    isResizable() {
      return this.$route.query.capture === 'true'
    },
  },
  watch: {
    '$store.getters.isPresenting': function watchIsPresenting() {
      this._updateBulletPointsIndex(0)
      this.checkShowBulletPoint()
      this._checkHyperlinks()
    },
    '$store.state.slideActive': function watchSlideActive() {
      this._checkHyperlinks()
      this.resizeContent()
      if (!this.isPresenting && !this.isBackstage) {
        this.makeColumn()
      }
      if (this.isPresenting || this.isBackstage) {
        this.checkShowBulletPoint()
      }

      if (this.slideId != this.$store.state.slideActive.id) {
        this.slideId = this.$store.state.slideActive.id
        this._updateBulletPointsIndex(0)
        this.makeColumn()
      }
      this._setClassFontSize()
      // this.isShowAudio = this._checkShowAudio()
    },
    activeSlideId() {
      if (this.$store.state.isAdmin || this.isDisableEditPresentation) return
      this.checkBulletPointsPresenting(this.isPresenting)
    },
  },
  mounted() {
    this.slideId = this.$store.state.slideActive.id
    this.makeColumn()
    this._updateBulletPointsIndex(0)
    this.checkShowBulletPoint()
    this._checkHyperlinks()
    this._setClassFontSize()
    this.resizeContent({ delay: 500 })
    // this.isShowAudio = this._checkShowAudio()

    if (this.isResizable) {
      Util.disallowPDFRender()

      setTimeout(() => {
        Util.allowPDFRender()
      }, 3000)
    }
    if (!this.$store.state.isAdmin) {
      this.checkBulletPointsPresenting(this.isPresenting)
    }
    EventBus.$on('next-back-slide: update-bulletPointsIndex', (isAllBulletPointsVisible, mode) => {
      this.handleUpdateBulletPointsIndex(isAllBulletPointsVisible, mode)
    })
  },
  destroyed() {
    clearTimeout(this.timer)
    EventBus.$off('next-back-slide: update-bulletPointsIndex')
    Util.allowPDFRender()
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction']),
    resizeContent(options = {}) {
      const { delay = 100 } = options

      if (!this.isResizable) return

      if (this.timer) {
        clearTimeout(this.timer)
      }

      this.timer = setTimeout(() => {
        const viewPortHeight = this.$refs.bulletList.clientHeight
        const listHeight = this.$refs.bulletContent.clientHeight

        if (listHeight > viewPortHeight && this.fontSize > this.minFontSize) {
          this.fontSize--
          this.trend = 'decrease'
          this.resizeContent()
          return
        }

        if (
          listHeight < viewPortHeight
          && this.fontSize < this.maxFontSize
          && this.trend === null
        ) {
          this.fontSize++
          this.resizeContent()
        }

        this.trend = null
      }, delay)
    },
    // _checkShowAudio() {
    //   if (this.$store.state.slideActive.id && this.$store.state.slideActive.audioLink) {
    //     if (this.$store.state.slideActive.audioShowControl) {
    //       return true
    //     }
    //   }
    //   return false
    // },
    checkShowBulletPoint() {
      let index = null
      if (this.bulletPoints.length) {
        index = 0
      }
      this.bulletPoints.forEach((arr) => {
        arr.forEach((item) => {
          if (index < this.$store.state.slideActive.bulletPointsIndex) {
            if (!item.show) {
              item.show = true
            }
          } else if (item.show) {
            item.show = false
          }
          index++
        })
      })

      this.bulletPoints.push()
    },
    async _updateBulletPointsIndex(index) {
      if (!this.$store.state.slideActive.id || this.$store.state.sharePresentation) return
      this.updateSlideActiveAction({
        bulletPointsIndex: index,
      })

      this.setSyncLoadingAction(1)
      try {
        await SlideApi.updateSlideById(this.slideActive.id, {
          bulletPointsIndex: index,
          socketId: Socket.getSocketId(),
          accessCode: this.$store.state.presentation.uniqueAccessCode,
          presenting: this.$store.getters.isPresenting,
          timestamp: new Date().getTime(),
        })
        this.setSyncLoadingAction(2)
      } catch (error) {
        this.setSyncLoadingAction(3)
      }
    },
    tabBulletPoint() {
      if (this.slideActive.bulletPointsIndex == this.slideActive.SlideOptions.length) return
      this.slideActive.bulletPointsIndex++
      this.checkShowBulletPoint()
      this._updateBulletPointsIndex(this.slideActive.bulletPointsIndex)
    },
    makeColumn() {
      let arr = [[]]
      let middleIndex
      const options = this.slideActive.SlideOptions.slice(0, 15)
      if (options.length < 6) {
        arr[0] = options
      } else {
        if (options.length < 11) {
          middleIndex = Math.ceil(options.length / 2)
          arr = [[], []]
        } else {
          middleIndex = Math.ceil(options.length / 3)
          arr = [[], [], []]
        }
        options.forEach((item, key) => {
          if (key < 15) {
            if (options.length < 10) {
              if (key < middleIndex) {
                arr[0].push(item)
              } else {
                arr[1].push(item)
              }
            } else if (key < middleIndex) {
              arr[0].push(item)
            } else if (key < middleIndex * 2) {
              arr[1].push(item)
            } else {
              arr[2].push(item)
            }
          }
        })
      }
      this.bulletPoints = arr
      this.bulletPoints.push()
    },
    _editSubheading() {
      if (this.$store.getters.isPresenting) return
      if (this.slideActive.activeTab != 2) {
        this.updateSlideActiveAction({
          activeTab: 2,
        })
      }
      setTimeout(() => {
        const subheading = document.getElementById('subheading-slide-edit')
        if (!subheading) return
        if (subheading.classList.contains('input-focus')) {
          subheading.classList.remove('input-focus')
        }
        subheading.focus()
        subheading.classList.add('input-focus')
      }, 100)
      Util.mixpanelTracking(
        'Slide',
        'Edit text slide',
        'Start editing subheading on preview screen',
      )
    },
    _editBulletPoints(e, id) {
      if (this.$store.getters.isPresenting) return
      const index = this.$store.state.slideActive.SlideOptions.findIndex((item) => {
        return item.id == id
      })
      if (this.slideActive.activeTab != 2) {
        this.updateSlideActiveAction({
          activeTab: 2,
        })
      }
      setTimeout(() => {
        const bullets = document.getElementById(`multipleChoiceIndex${index}`)
        if (!bullets) return
        if (bullets.classList.contains('input-focus')) {
          bullets.classList.remove('input-focus')
        }
        bullets.focus()
        bullets.classList.add('input-focus')
      }, 100)
      Util.mixpanelTracking(
        'Slide',
        'Edit text slide',
        'Start editing a bullet point on preview screen',
      )
    },
    _checkHyperlinks() {
      if (this.$store.state.slideActive.title) {
        this.title = Util.sanitize(this.$store.state.slideActive.title, true)
      }
      if (this.$store.state.slideActive.subheading) {
        this.subheading = Util.sanitize(this.$store.state.slideActive.subheading, true)
      }
    },
    _setClassFontSize() {
      if (this.slideActive.title) {
        // title
        this.classHeading = 'heading-md-title'
        this.classSubheading = 'subheading-md-title'
        this.classBullet = 'bullet-md'
        if (
          this.slideActive.title.length >= 70 &&
          this.slideActive.title.length <= 110
        ) {
          this.classHeading = 'heading-sm-title'
          this.classSubheading = 'subheading-sm-title'
          this.classBullet = 'bullet-sm'
        } else if (this.slideActive.title.length > 110 && this.slideActive.title.length <= 180) {
          this.classHeading = 'heading-xs-title'
          this.classSubheading = 'subheading-xs-title'
          this.classBullet = 'bullet-xs'
        } else if (this.slideActive.title.length > 180) {
          this.classHeading = 'heading-2xs-title'
          this.classSubheading = 'subheading-2xs-title'
          this.classBullet = 'bullet-2xs'
        }
      } else {
        //! title
        this.classHeading = 'heading-sm-title'
        this.classSubheading = 'subheading-md-title'
        this.classBullet = 'bullet-sm'
        //! title && subheading
        if (this.$store.state.slideActive.subheading) {
          if (
            this.$store.state.slideActive.subheading.length >= 70 &&
            this.$store.state.slideActive.subheading.length <= 110
          ) {
            this.classSubheading = 'subheading-sm-title'
            this.classBullet = 'bullet-sm'
          } else if (this.$store.state.slideActive.subheading.length > 110) {
            this.classSubheading = 'subheading-xs-title'
            this.classBullet = 'bullet-xs'
          }
        } else {
          //! title && !subheading
          this.classSubheading = 'subheading-sm-title'
          this.classBullet = 'bullet-sm'
        }
      }
    },
    checkBulletPointsPresenting(isPresenting) {
      if (this.slideActive.type == 'bulletPoints') {
        const options = []
        this.slideActive.SlideOptions.forEach((item) => {
          if (item.title) {
            options.push(item)
          }
        })

        if (!options.length) {
          if (isPresenting) {
            this.updateSlideActiveAction({
              SlideOptions: options,
            })
          } else {
            this.updateSlideActiveAction({
              SlideOptions: [
                {
                  index: 1,
                  order: 1,
                },
                {
                  index: 2,
                  order: 2,
                },
                {
                  index: 3,
                  order: 3,
                },
              ],
            })
          }
        } else if (isPresenting) {
          this.updateSlideActiveAction({
            SlideOptions: options,
          })
        }
      }
    },

    handleUpdateBulletPointsIndex(isAllBulletPointsVisible, mode) {
      if (!isAllBulletPointsVisible && mode == 'next') {
        this.updateSlideActiveAction({
          bulletPointsIndex: this.slideActive.bulletPointsIndex + 1,
        })
      }
      if (!isAllBulletPointsVisible && mode == 'prev') {
        this.updateSlideActiveAction({
          bulletPointsIndex: this.slideActive.bulletPointsIndex - 1,
        })
      }
      this._updateBulletPointsIndex(this.slideActive.bulletPointsIndex)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.bullet-title {
  margin: 0 auto;
  text-align: center;
  position: relative;
  padding: 0 40px;
  .bullet-list {
    word-break: break-word;
    &.bullet-md {
      font-size: 32px;
    }
    &.bullet-sm {
      font-size: 29px;
    }
    &.bullet-xs {
      font-size: 26px;
    }
    ul {
      padding-left: 0;
    }
  }
  .bullet-subheading {
    white-space: pre-line;
    width: 80%;
    word-break: break-word;
    margin: 0 auto;
    margin-bottom: 8px;
    cursor: pointer;
    opacity: 0.85;
    padding: 0 8px;
  }

  .bullet-point-content {
    width: 100%;
    line-height: initial;
    margin-top: 40px;
    text-align: left;
    overflow-y: auto;
    overflow-x: hidden;
    margin-bottom: 75px;
  }
  .bullet-list-listing {
    cursor: pointer;
    min-width: 120px;
  }
  .box-clumn {
    width: 100%;
  }
  .box-max-h {
    max-height: 100%;
  }
  .bullet-column {
    text-align: left;
  }
  .column-layout {
    max-width: 400px;
    padding: 0 50px;
  }
}
.popup-enter-active {
  transition: all 0.4s ease;
}
.popup-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
  transform: scale(1.5);
}
.popup-enter, .popup-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: scale(0.5);
  opacity: 0;
}

.bullet-heading {
  font-weight: bold;
  line-height: 1.2;
  padding-bottom: 15px;
}

.bullet-title {
  height: calc(100% + 79px);
  width: 100%;
}
.bullet-presenting {
  .bullet-subheading,
  .bullet-list-listing {
    transition: all 0.3s ease;
    cursor: default;
  }

  .hide-bullet-point {
    .bullet-list-listing {
      opacity: 0;

      &.show {
        opacity: 1;
      }
    }
  }
}
</style>
